import { Flame, ArrowRight } from 'lucide-react';

import { HOLIDAY_CAMPAIGN } from '../config/campaign';

import { useHolidayStore } from '@/store/useHolidayStore';

export function PhraseRevealModal() {
  const { showPhraseReveal, setShowPhraseReveal, setShowTweetModal } = useHolidayStore();

  if (!showPhraseReveal) return null;

  const handleContinue = () => {
    setShowPhraseReveal(false);
    // Open Twitter to reply to the official tweet
    const tweetText = encodeURIComponent(`${HOLIDAY_CAMPAIGN.REQUIRED_MESSAGE}\n\n@friend1 @friend2`);
    window.open(
      `https://twitter.com/intent/tweet?text=${tweetText}&in_reply_to=${HOLIDAY_CAMPAIGN.OFFICIAL_TWEET_ID}`,
      '_blank',
      'width=600,height=400'
    );
    // After a delay, show the tweet verification modal
    setTimeout(() => {
      setShowTweetModal(true);
    }, 2000);
  };

  const handleSkipToVerify = () => {
    setShowPhraseReveal(false);
    setShowTweetModal(true);
  };

  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center bg-black/80 backdrop-blur-md animate-modal-backdrop-in"
      onClick={() => {}}
    >
      <div
        className="relative max-w-lg mx-4 text-center"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Fire decorations */}
        <div className="absolute -top-16 left-1/2 -translate-x-1/2 flex gap-4">
          <Flame className="w-12 h-12 text-orange-500 animate-pulse" style={{ animationDelay: '0s' }} />
          <Flame className="w-16 h-16 text-orange-400 animate-pulse" style={{ animationDelay: '0.2s' }} />
          <Flame className="w-12 h-12 text-orange-500 animate-pulse" style={{ animationDelay: '0.4s' }} />
        </div>

        {/* Main phrase reveal */}
        <div
          className="bg-gradient-to-b from-orange-900/90 via-red-900/90 to-black/90 rounded-2xl p-8 border-2 border-orange-500/50 shadow-2xl"
          style={{
            boxShadow: '0 0 60px rgba(251, 139, 0, 0.4), 0 0 100px rgba(255, 100, 0, 0.2)',
          }}
        >
          {/* The reveal image */}
          <div className="mb-6">
            <img
              src="/burnpast.png"
              alt="Burn the past. Ignite the future."
              className="w-full max-w-md mx-auto animate-pulse"
              style={{
                filter: 'drop-shadow(0 0 30px rgba(255, 150, 0, 0.5))',
              }}
            />
          </div>

          {/* Instructions */}
          <div className="bg-black/40 rounded-xl p-4 mb-6">
            <p
              className="text-white text-lg mb-3"
              style={{ fontFamily: 'Outfit, sans-serif' }}
            >
              Now share this message to complete the ritual!
            </p>
            <div className="text-gray-300 text-sm space-y-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
              <p>1. Reply to our official tweet with this phrase</p>
              <p>2. Tag 2 friends to spread the fire</p>
              <p>3. Come back and verify your reply</p>
            </div>
          </div>

          {/* Action buttons */}
          <div className="space-y-3">
            <button
              onClick={handleContinue}
              className="w-full py-4 px-6 rounded-xl font-bold text-black transition-all transform hover:scale-105 flex items-center justify-center gap-2"
              style={{
                background: 'linear-gradient(92deg, #FB8B00 -4.02%, #F6DF6F 24.3%, #FB8B00 50.55%, #F6DF6F 72.17%, #FB8B00 103.05%)',
                fontFamily: 'Hyperspace Race Capsule, cursive',
                fontSize: '1.1rem',
              }}
            >
              REPLY ON TWITTER
              <ArrowRight className="w-5 h-5" />
            </button>

            <button
              onClick={handleSkipToVerify}
              className="w-full py-3 px-6 rounded-xl font-medium text-gray-300 hover:text-white transition-colors text-sm"
              style={{ fontFamily: 'Outfit, sans-serif' }}
            >
              I already replied - Verify my tweet
            </button>
          </div>
        </div>

        {/* Bottom fire glow */}
        <div
          className="absolute -bottom-8 left-1/2 -translate-x-1/2 w-3/4 h-16 rounded-full opacity-60"
          style={{
            background: 'radial-gradient(ellipse, rgba(255, 100, 0, 0.6) 0%, transparent 70%)',
            filter: 'blur(20px)',
          }}
        />
      </div>
    </div>
  );
}
